// Returns a list of resources by IDs or list name
export default function (state, resourceName, filter) {
  var resourceSlice = void 0,
      filterToUse = void 0;
  if (!filter) {
    resourceSlice = state;
    filterToUse = resourceName;
  } else {
    resourceSlice = state[resourceName];
    filterToUse = filter;
  }

  if (!resourceSlice) {
    return [];
  }

  var resources = resourceSlice.resources;
  var idsList = void 0;

  if (typeof filterToUse === 'function') {
    return Object.values(resources).filter(function (resource) {
      return filterToUse(resource, resourceSlice.meta[resource.id], resourceSlice);
    });
  }

  // This conditional handles the situation where `filter` is an list name
  else if (typeof filterToUse === 'string') {
      var list = resourceSlice.lists[filterToUse];
      if (!list) {
        return [];
      }

      idsList = list;
    } else {
      idsList = filterToUse;
    }

  if (!(idsList && idsList.length)) {
    return [];
  }

  return idsList.map(function (id) {
    return resources[id];
  }).filter(Boolean);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/utils/get-resources.js
// module id = 1033
// module chunks = 2